import { Grid, Box, Bones } from '@simplywallst/ui-core';
import { Tile } from '@/components/Tile';

const TileSkeleton = () => (
  <Tile>
    <div className="bg-surface-2">
      <Tile.Header>
        <div className="bg-surface-1">
          <Box height="143px" overflow="hidden">
            <Bones />
            <Bones />
            <Bones />
            <Bones />
            <Bones />
            <Bones />
            <Bones />
            <Bones />
            <Bones />
          </Box>
        </div>
      </Tile.Header>
      <Grid
        height="326px"
        paddingTop="x13"
        paddingLeft="x3"
        paddingRight="x3"
        templateColumns="auto 120px"
        gap="8px"
        alignItems="center"
      >
        <Box maxWidth="300px" paddingRight="x4">
          <Bones marginBottom="x1" minHeight="17px" />
          <Bones minHeight="17px" maxWidth="80%" />
        </Box>
        <Box>
          <div className="size-[110px] rounded-full bg-surface-3" />
        </Box>
      </Grid>
      <Tile.Footer>
        <Grid
          templateColumns="repeat(3, 16px) 60px 50px"
          gap="10px"
          alignItems="center"
          paddingBottom="x2"
          paddingLeft="x3"
        >
          <Bones borderRadius="x1" />
          <Bones borderRadius="x1" />
          <Bones borderRadius="x1" />
          <Bones />
          <Bones borderRadius="x2" />
        </Grid>
      </Tile.Footer>
    </div>
  </Tile>
);

export const LoadingSkeleton = () => (
  <Box marginLeft="x2" marginRight="x2" marginLeftLg="x0" marginRightLg="x0">
    <Grid
      gap="24px"
      templateColumnsMd="repeat(2, minmax(0, 1fr))"
      templateColumnsLg="repeat(3, minmax(0, 1fr))"
      width="100%"
      data-cy-id="tile-view"
    >
      <TileSkeleton />
      <TileSkeleton />
      <TileSkeleton />
    </Grid>
  </Box>
);
